import { createApp } from 'vue';
import ArwToJpgConverter from '../Components/ArwToJpgConverter.vue';

const root = document.getElementById('arw-to-jpg-converter');
if (root) {
  createApp(ArwToJpgConverter).mount('#arw-to-jpg-converter');
}
